import {
  IFormData,
  IFieldValidation,
  FieldValidationType,
} from '../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import {
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All,
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel,
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel__Associations_Fakturaattest,
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All,
} from '../../../Queries/_QueryTypes/FakturaDelQuery';
import {
  IKodstrang,
  IKonteringValidationError,
} from '../../../../../../_Common/Components/KonteringManager/KonteringManager';
import { BELOPP_FIELD_NAME } from '../KonteringsForslagComp';
import {
  TEDEKKontodelREDOVISN_TYPEnum,
  TEDLRFakturaAttestAttestTypEnum,
  TEDLRFakturaAttestSTATUSEnum,
  TEDLRLeverantorfakturaMOMSHANTERINGEnum,
  TEDSelectionOperator,
  TEDSelectionVisibility,
} from '../../../../../../../../globalQueryTypes';
import { IAktuellFakturaAttestInfo } from '../../../Utils/FakturadelUtils';
import { ReservForQuery_reservForKodbehorigheter } from '../../../../Attestant/Components/ReservFor/Queries/_QueryTypes/ReservForQuery';
import { convertUrval } from '../../../../../../../../Components/Urval/Components/SavedUrval/Utils/convertSavedUrval';
import { EK_KONTO_URVAL_COLLECTION_NAME } from '../../../../../../../../Components/Urval/Consts/UrvalConsts';
import { AvenyCollectionMap } from '../../../../../../../../Model/ModelContext/ModelContext';
import { IAttestKodbehorighetUrval } from '../../../../../../_Common/Components/KonteringManager/KonteringContext';
import { equals } from 'ramda';

import EDIcon from '../../../../../../../../BaseComponents/Icon/EDIcon';
import { IKonteringsforslagUpdateObject } from '../../FakturaDelContextManager/FakturaDelContext';

export interface IKontodelFromAssoc {
  id: string;
  KONTODEL: string;
  BENAMNING: string | null;
  LOPNR: number;
}

export const kontodelIsNotNull = (
  arg: IKontodelFromAssoc | null
): arg is IKontodelFromAssoc => arg != null;
export const stringIsNotNull = (
  arg: string | null | undefined
): arg is string => arg != null;

interface IReservAttestRatt {
  _Associations?: {
    Reserver?: Array<{
      _Associations?: {
        Reserv?: {
          _Associations?: {
            Attestant?: {
              _Associations?: {
                Anvandare?: {
                  SIGNATURE: string;
                } | null;
              } | null;
            } | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
}

const isReserv = (
  attestRatt: IReservAttestRatt | undefined | null,
  userSign: string
) =>
  attestRatt?._Associations?.Reserver?.some(
    reserv =>
      reserv?._Associations?.Reserv?._Associations?.Attestant?._Associations?.Anvandare?.SIGNATURE.toLowerCase() ===
      userSign.toLowerCase()
  ) ?? false;

export const iAmBeslutsAttestantOnKontering = (
  kf:
    | FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All
    | undefined,
  minFakturaAttest: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All | null
) => {
  if (!kf || !minFakturaAttest) {
    return false;
  }
  return kf._Associations?.Fakturaattest?.id === minFakturaAttest?.id;
};

export const iAmReservForForslag = (
  userSign: string,
  dataform: any,
  kf: any
) => {
  const realAttest = (dataform._Associations as any)?.Fakturaattest?.find(
    (fa: any) => fa.id === kf._Associations?.Fakturaattest?.id
  );
  return Boolean(
    realAttest &&
      realAttest?._Associations?.Attestratt?._Associations?.Reserver?.find(
        (reserv: any) =>
          reserv._Associations?.Reserv?._Associations?.Attestant?._Associations?.Anvandare?.SIGNATURE?.toLowerCase() ===
          userSign
      )
  );
};

export const iAmLastBeslutsAttestant = (
  minAttest: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All | null,
  attester: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[],
  userSign: string
) => {
  return (
    attester?.filter(
      attest =>
        attest.AttestTyp === TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST &&
        attest.id !== minAttest?.id &&
        !isReserv(attest._Associations?.Attestratt as any, userSign) &&
        attest.STATUS !== TEDLRFakturaAttestSTATUSEnum.ATTESTERAD
    ).length === 0
  );
};

export const getOrdinarieKodbehorigheter = (
  reservKodbehorigheter:
    | (ReservForQuery_reservForKodbehorigheter | null)[]
    | null
    | undefined,
  minFakturaAttest: IAktuellFakturaAttestInfo,
  kodplanId: string | undefined,
  avenyCollectionMap: AvenyCollectionMap,
  attestKodbehorigheterUrval: IAttestKodbehorighetUrval[] | null,
  requireMotKodbeh: boolean
) => {
  let result: IAttestKodbehorighetUrval[] | undefined;

  const kodBeh =
    !requireMotKodbeh &&
    (attestKodbehorigheterUrval?.length === 0 ||
      attestKodbehorigheterUrval == null)
      ? createTemplateWholeBookKodbeh(minFakturaAttest, kodplanId ?? '')
      : attestKodbehorigheterUrval;
  if (
    minFakturaAttest.isReserv &&
    minFakturaAttest.aktuellFakturaAttest?._Associations?.Attestratt?.id ===
      minFakturaAttest.reservAttestratt.attestrattID
  ) {
    result =
      reservKodbehorigheter
        ?.filter(elem => {
          return (
            elem?.attestRattID === minFakturaAttest?.ordinarieAttestratt?.id &&
            elem.kodplanID === kodplanId &&
            (elem.attestTyp === 'B' ||
              minFakturaAttest.aktuellFakturaAttest?.AttestTyp ===
                TEDLRFakturaAttestAttestTypEnum.MOTTAGNINGSATTEST)
          );
        })
        .map(kodbeh => ({
          urval: convertUrval(
            kodbeh?.attestKodbehorighet,
            EK_KONTO_URVAL_COLLECTION_NAME,
            avenyCollectionMap
          ),
          omradesId: kodbeh?.omradeID,
          kodplanID: kodbeh?.kodplanID,
          attestRattID: kodbeh?.attestRattID,
          attestTyp: kodbeh?.attestTyp,
          maxbelopp: kodbeh?.maxbelopp,
          kontrollbelopp: kodbeh?.kontrollbelopp,
          hasKontrollAttestant: kodbeh?.hasKontrollAttestant,
        })) ?? [];
  } else {
    result = kodBeh?.filter(
      kodbehorighetUrval =>
        kodbehorighetUrval.attestRattID ===
          minFakturaAttest?.ordinarieAttestratt?.id &&
        kodbehorighetUrval.kodplanID === kodplanId &&
        (kodbehorighetUrval.attestTyp === 'B' ||
          minFakturaAttest.aktuellFakturaAttest?.AttestTyp ===
            TEDLRFakturaAttestAttestTypEnum.MOTTAGNINGSATTEST)
    );
  }

  return result;
};

export const getAllFakturaAttester = (
  dataFormFakturaDelar: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel[]
): FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel__Associations_Fakturaattest[] => {
  let allaFakturaAttester: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel__Associations_Fakturaattest[] =
    [];

  for (let index = 0; index < dataFormFakturaDelar?.length; index++) {
    const fakturadel = dataFormFakturaDelar?.[index];

    allaFakturaAttester = allaFakturaAttester?.concat(
      fakturadel._Associations?.Fakturaattest ?? []
    );
  }

  return allaFakturaAttester ?? [];
};

export const IsThereOnlyOneMottagningsAttestant = (
  dataFormFakturaAttest: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All[],
  dataFormFakturaDelar: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel[]
): boolean => {
  const mottagningsAttestanter = dataFormFakturaAttest?.filter(
    attestant =>
      attestant.AttestTyp === TEDLRFakturaAttestAttestTypEnum.MOTTAGNINGSATTEST
  );

  if (dataFormFakturaDelar && dataFormFakturaDelar?.length > 1) {
    return false;
  } else {
    return mottagningsAttestanter && mottagningsAttestanter.length === 1;
  }
};

export const getAutochangedKonteringsforslagList = (
  updatedAutoValues: IFormData | undefined
) => {
  if (updatedAutoValues) {
    const updatedAutoFakturaValues =
      updatedAutoValues?._Associations?.Faktura_Values;

    const autochangedKonteringsforslagList = (
      updatedAutoFakturaValues?._Associations
        ?.Konteringsforslag_Update_Values ?? []
    ).concat(
      updatedAutoFakturaValues?._Associations?.Konteringsforslag_Add_Values ??
        []
    );

    return autochangedKonteringsforslagList;
  } else {
    return [];
  }
};

export const getKodstrangar = (
  kontering: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All
) => ({
  id: kontering.id,
  belopp: kontering.DEBET - kontering.KREDIT,
  kontodelar: getAllKontodelar(kontering?._Associations)
    .filter(kontodelIsNotNull)
    .filter(kontodel => (kontering as unknown as Record<string, unknown>)[`KONTOID_${kontodel.LOPNR}`] != null)
    .map(kontodel => {
      return {
        benamning: kontodel?.BENAMNING ?? 'Saknas',
        kontodel: kontodel?.KONTODEL ?? 'Saknas',
        ordningsNr: kontodel?.LOPNR,
        id: kontodel?.id,
        lopnr: kontodel.LOPNR,
      };
    }),
});

export const findKodbehWithHighestMaxbelopp = (
  correctnessKodbeh: IAttestKodbehorighetUrval[]
) => {
  if (correctnessKodbeh.length === 0) {
    return undefined;
  }
  let maxbeloppKodbeh = correctnessKodbeh[0];
  let currentHighestMaxbelopp = -1;

  for (let i = 0; i < correctnessKodbeh.length; i++) {
    const currentMaxbeloppCheck = correctnessKodbeh[i]?.maxbelopp;
    if (currentMaxbeloppCheck == null) {
      return correctnessKodbeh[i];
    }
    if (currentMaxbeloppCheck > currentHighestMaxbelopp) {
      currentHighestMaxbelopp = currentMaxbeloppCheck;
      maxbeloppKodbeh = correctnessKodbeh[i];
    }
  }
  return maxbeloppKodbeh;
};

// Tar ut alla konteringsförslag som attestanten har ändrat på
export const getChangedForslag = (
  updatedValues: IFormData,
  updatedAutoValues: IFormData,
  allaForslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All[],
  allaForslagFromQuery: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All[]
): FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All[] => {
  const changedKonteringsForslagIDs: string[] = [];
  const updatedFakturaValues = updatedValues?._Associations?.Faktura_Values;

  const autochangedKonteringsforslagList: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All[] =
    getAutochangedKonteringsforslagList(updatedAutoValues);

  if (updatedFakturaValues == null) {
    return [];
  }

  updatedFakturaValues?._Associations?.Konteringsforslag_Update_Values?.forEach(
    (
      konteringsForslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All
    ) => {
      const autochangedKonteringsforslag =
        autochangedKonteringsforslagList.find(
          autoKf => autoKf.id === konteringsForslag.id
        );
      const originalForslag = allaForslagFromQuery.find(
        forslag => forslag.id === konteringsForslag.id
      );
      const updatedForslag = allaForslag.find(
        forslag => forslag.id === konteringsForslag.id
      );
      if (autochangedKonteringsforslag) {
        if (!equals(autochangedKonteringsforslag, konteringsForslag)) {
          changedKonteringsForslagIDs.push(konteringsForslag.id);
        }
      } else {
        if (updatedForslag && originalForslag) {
          const {
            KREDIT: updatedKredit,
            DEBET: updatedDebet,
            _Associations: updatedAssocs,
            ...updatedFieldsRest
          } = updatedForslag;
          const {
            KREDIT: originalKredit,
            DEBET: originalDebet,
            _Associations: originalAssoc,
            ...originalFieldsRest
          } = originalForslag;

          if (updatedAssocs == null || originalAssoc == null) {
            if (!equals(updatedAssocs, originalAssoc)) {
              changedKonteringsForslagIDs.push(konteringsForslag.id);
            }
            return;
          }

          const { Fakturaattest: updatedFakturaattest, ...updatedAssocRest } =
            updatedAssocs;

          const { Fakturaattest: originalFakturaattest, ...originalAssocRest } =
            originalAssoc;
          if (
            (originalDebet != updatedDebet ||
              originalKredit != updatedKredit) &&
            originalFakturaattest?.id != updatedFakturaattest?.id &&
            equals(updatedAssocRest, originalAssocRest) &&
            equals(originalFieldsRest, updatedFieldsRest)
          ) {
            return;
          } else if (
            !equals(updatedAssocRest, originalAssocRest) &&
            !equals(originalFieldsRest, updatedFieldsRest)
          ) {
            changedKonteringsForslagIDs.push(konteringsForslag.id);
          }
        } else {
          changedKonteringsForslagIDs.push(konteringsForslag.id);
        }
      }
    }
  );

  updatedFakturaValues?._Associations?.Konteringsforslag_Add_Values?.forEach(
    (
      konteringsForslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All
    ) => {
      const autochangedKonteringsforslag =
        autochangedKonteringsforslagList.find(
          autoKf => autoKf.id === konteringsForslag.id
        );

      if (autochangedKonteringsforslag) {
        if (!equals(autochangedKonteringsforslag, konteringsForslag)) {
          changedKonteringsForslagIDs.push(konteringsForslag.id);
        }
      }
    }
  );

  return allaForslag.filter(forslag =>
    changedKonteringsForslagIDs.includes(forslag.id)
  );
};

export const convertIKonteringValidationErrorToValidationErrorsType = (
  error: IKonteringValidationError,
  kodstrang: IKodstrang,
  touched: IFormData | undefined
): IFieldValidation => {
  return error.kontodel.includes(BELOPP_FIELD_NAME)
    ? {
        fieldName: error.kontodel,
        message: error.meddelande,
        type: error.type ?? 'Error',
      }
    : {
        fieldName: kodstrang.id + ' ' + error.lopnr?.toString(),
        message: error.meddelande,
        type: error.type ?? 'Error',
        showAsHint:
          error.showAsHint ??
          !touched?._Associations?.[`Kontodel${error.lopnr}`],
      };
};

interface IKonteringsforslagAssociation {
  Kontodel1: IKonteringsforslagAssociationKontodel | null;
  Kontodel2: IKonteringsforslagAssociationKontodel | null;
  Kontodel3: IKonteringsforslagAssociationKontodel | null;
  Kontodel4: IKonteringsforslagAssociationKontodel | null;
  Kontodel5: IKonteringsforslagAssociationKontodel | null;
  Kontodel6: IKonteringsforslagAssociationKontodel | null;
  Kontodel7: IKonteringsforslagAssociationKontodel | null;
  Kontodel8: IKonteringsforslagAssociationKontodel | null;
  Kontodel9: IKonteringsforslagAssociationKontodel | null;
  Kontodel10: IKonteringsforslagAssociationKontodel | null;
}

interface IKonteringsforslagAssociationKontodel {
  id: string;
  KONTODEL: string;
  BENAMNING: string | null;
}

export const roundToTwoDecimals = (value: number) => {
  return Math.round(value * 100) / 100;
};

/**
 * Round off a number to number of decimals
 * @param {number} value - Value that you want to round
 * @param {number} numberOfDecimals - Number of decimals to round to, set to 0 to just get the integer part of the number
 * @returns {number}
 */
export const roundNumberToDecimals = (
  value: number,
  numberOfDecimals: number = 2
): number => {
  if (numberOfDecimals < 1) {
    return Math.trunc(value);
  }

  const roundingNumber = numberOfDecimals * 10;

  return Math.round(value * roundingNumber) / roundingNumber;
};

export const getAllKontodelarBen = (
  associations: IKonteringsforslagAssociation | null | undefined
): string[] => {
  return getAllKontodelar(associations).map(kontodel =>
    kontodel ? kontodel.BENAMNING ?? '' : ''
  );
};

export const getOtherBeslutAttestanter = (
  fakturaAttester: {
    AttestTyp: TEDLRFakturaAttestAttestTypEnum | null;
    _Associations: { Attestratt: { id: string } | null } | null;
    STATUS: TEDLRFakturaAttestSTATUSEnum;
  }[],
  signedInUserAttestrattId: string | null | undefined
): FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel__Associations_Fakturaattest[] => {
  const result = fakturaAttester.filter(fakturaAttest => {
    return (
      (fakturaAttest.AttestTyp ===
        TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST &&
        fakturaAttest._Associations?.Attestratt?.id !==
          signedInUserAttestrattId) ??
      ''
    );
  });

  return result as FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel__Associations_Fakturaattest[];
};

export const konteringSaknas = (
  konteringsforslagAssociation: IKonteringsforslagAssociation | null | undefined
): boolean =>
  getAllKontodelar(konteringsforslagAssociation).every(kf => kf == null);

export const getAllKontodelar = (
  associations: IKonteringsforslagAssociation | any | null | undefined
): Array<IKontodelFromAssoc | null> => {
  const res: Array<IKontodelFromAssoc | null> = [];

  if (!associations) {
    return res;
  }

  if (associations.Kontodel1 || associations.Kontodel1_Ref) {
    res.push({ ...associations.Kontodel1, LOPNR: 1 });
  } else {
    res.push(associations.Kontodel1);
  }
  if (associations.Kontodel2 || associations.Kontodel2_Ref) {
    res.push({ ...associations.Kontodel2, LOPNR: 2 });
  } else {
    res.push(associations.Kontodel2);
  }
  if (associations.Kontodel3 || associations.Kontodel3_Ref) {
    res.push({ ...associations.Kontodel3, LOPNR: 3 });
  } else {
    res.push(associations.Kontodel3);
  }
  if (associations.Kontodel4 || associations.Kontodel4_Ref) {
    res.push({ ...associations.Kontodel4, LOPNR: 4 });
  } else {
    res.push(associations.Kontodel4);
  }
  if (associations.Kontodel5 || associations.Kontodel5_Ref) {
    res.push({ ...associations.Kontodel5, LOPNR: 5 });
  } else {
    res.push(associations.Kontodel5);
  }
  if (associations.Kontodel6 || associations.Kontodel6_Ref) {
    res.push({ ...associations.Kontodel6, LOPNR: 6 });
  } else {
    res.push(associations.Kontodel6);
  }
  if (associations.Kontodel7 || associations.Kontodel7_Ref) {
    res.push({ ...associations.Kontodel7, LOPNR: 7 });
  } else {
    res.push(associations.Kontodel7);
  }
  if (associations.Kontodel8 || associations.Kontodel8_Ref) {
    res.push({ ...associations.Kontodel8, LOPNR: 8 });
  } else {
    res.push(associations.Kontodel8);
  }
  if (associations.Kontodel9 || associations.Kontodel9_Ref) {
    res.push({ ...associations.Kontodel9, LOPNR: 9 });
  } else {
    res.push(associations.Kontodel9);
  }
  if (associations.Kontodel10 || associations.Kontodel1_Ref) {
    res.push({ ...associations.Kontodel10, LOPNR: 10 });
  } else {
    res.push(associations.Kontodel10);
  }

  return res;
};

export const trimTrailingDashes = (s: string): string => {
  const regexp = new RegExp('-' + '+$');
  return s.replace(regexp, '');
};

/**
 * Skapar upp en "Hela Huvudboken" kodbehörighet
 * @param minFakturaAttest  minFakturaAttest från fakturaDelContext
 * @param kodplanID  Aktuell kodplans ID
 * @returns IAttestKodbehorighetUrval[]
 */
export const createTemplateWholeBookKodbeh = (
  minFakturaAttest: IAktuellFakturaAttestInfo,
  kodplanID: string
): IAttestKodbehorighetUrval[] => [
  {
    attestRattID: minFakturaAttest.aktuellFakturaAttest?.id,
    attestTyp: 'M',
    kodplanID: kodplanID,
    omradesId: 'template',
    maxbelopp: null,
    hasKontrollAttestant: null,
    kontrollbelopp: null,
    urval: {
      pages: [
        {
          id: 'template',
          conditionObjects: [
            {
              id: 'KONTODEL_1 - -m32Ui_WdF',
              modelPath: [],
              attribute: {
                AttributeName: 'KONTODEL_1',
                DisplayLabel: 'Baskonto',
                Hint: '',
                DataType: 'String',
                EnumValues: new Map(),
                Attribute: 'Internal',
                Condition: 'Normal',
                Formatter: '',
                FormatterParseParams: '',
                FormatterDisplayParams: '',
                FormatterValidateParams: '',
                GUIEditable: false,
                InterfaceType: 'ifString',
                CondOperators: [
                  TEDSelectionOperator.starts,
                  TEDSelectionOperator.notstarts,
                  TEDSelectionOperator.contains,
                  TEDSelectionOperator.notcontains,
                  TEDSelectionOperator.equals,
                  TEDSelectionOperator.notequals,
                  TEDSelectionOperator.interval,
                  TEDSelectionOperator.notinterval,
                  TEDSelectionOperator.notless,
                  TEDSelectionOperator.greater,
                  TEDSelectionOperator.notgreater,
                  TEDSelectionOperator.less,
                  TEDSelectionOperator.hasvalue,
                  TEDSelectionOperator.isnull,
                ],
                DefaultCondOperator: TEDSelectionOperator.interval,
                ValidInComps: [],
                AttributeGroup: 'Baskonto',
                AttributeParams: {},
                Properties: new Map(),
              },
              condition: [
                {
                  id: 'Yw4bsOcbxk',
                  op: TEDSelectionOperator.interval,
                  values: [
                    {
                      id: '4yKIJ7BLj3',
                      value: '',
                      toValue: '9999',
                    },
                  ],
                },
              ],
              type: 'String',
            },
          ],
        },
      ],
      savedUrvalProps: {
        id: 'template',
        namn: 'Hela huvudboken',
        anvFavorit: false,
        collection: 'EKKonto',
        order: null,
        rutinID: null,
        synligAnvID: null,
        synligGruppID: null,
        synlighet: TEDSelectionVisibility.standard,
        urvalID: 'template',
        beskrivning: null,
      },
    },
  },
];

export const getStatusIcon = (validationErrors: IFieldValidation[]) => {
  if (validationErrors?.filter(item => item.type === 'Error')?.length != 0) {
    return <EDIcon iconType="error" color="error" key="error" />;
  } else if (
    validationErrors?.filter(item => item.type === 'Warning')?.length != 0
  ) {
    return <EDIcon iconType="warning" color="warning" key="warning" />;
  }

  return undefined;
};

export const getBeloppErrors = (
  kodstrangId: string | undefined,
  validations: IFieldValidation[],
  validationType: FieldValidationType
) => {
  if (kodstrangId) {
    const result = validations.filter(v => {
      return (
        kodstrangId.includes(v.fieldName.split(' ')[0]) &&
        v.fieldName.includes(BELOPP_FIELD_NAME) &&
        v.type === validationType
      );
    });

    if (result && result[0] && result[0].message) {
      return result[0].message;
    }
  }

  return '';
};

export const getCertiferValidation = (
  kodstrangId: string | undefined,
  validations: IFieldValidation[],
  validationType: FieldValidationType
) => {
  if (kodstrangId) {
    const result = validations.filter(v => {
      return (
        kodstrangId.includes(v.fieldName.split(' ')[0]) &&
        v.fieldName.includes('attestant') &&
        v.type === validationType
      );
    });

    if (result && result[0] && result[0].message) {
      return result[0].message;
    }
  }

  return '';
};

export const getKostnadsBelopp = (
  radtyp: number | null | undefined,
  beloppInklMoms: number,
  beloppExklMoms: number,
  ingMomsSats: number | null | undefined,
  avdragsratt: number,
  customIngMomsBelopp: number | null | undefined,
  utlandskMomsSats: number | null | undefined,
  utlandskMomsBelopp: number | null | undefined
) => {
  switch (radtyp) {
    case 1:
      return beloppExklMoms;
    case 3:
      return beloppInklMoms;
    case 4:
      if (customIngMomsBelopp != null) {
        return beloppInklMoms - customIngMomsBelopp;
      } else {
        return (
          beloppInklMoms -
          getIngaendeMoms(beloppInklMoms, true, ingMomsSats, avdragsratt)
        );
      }

    case 5:
    case 6:
      if (utlandskMomsBelopp != null) {
        return (
          beloppExklMoms +
          utlandskMomsBelopp -
          roundToTwoDecimals(utlandskMomsBelopp * avdragsratt)
        );
      } else {
        return getUtlandskKostnad(
          beloppExklMoms,
          utlandskMomsSats,
          avdragsratt
        );
      }
    default:
      return 0;
  }
};

export const getKonteratBelopp = (
  konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All[]
): number => {
  let konteratBelopp: number = roundToTwoDecimals(
    konteringsforslag?.reduce(
      (
        prev: any,
        curr: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All
      ) => {
        switch (curr.RADTYP) {
          case 0:
          case null:
          case undefined:
          case 2:
            if (curr.KREDIT == null || curr.DEBET == null) {
              return prev;
            }
            if (curr.KREDIT > 0) {
              return prev - curr.KREDIT;
            } else {
              return prev + curr.DEBET;
            }

          case 1:
          case 5:
          case 6:
            if (curr.BELOPP_EXKL_MOMS) {
              return prev + curr.BELOPP_EXKL_MOMS;
            } else {
              return prev;
            }

          case 3:
          case 4:
            if (curr.BELOPP_INKL_MOMS) {
              return prev + curr.BELOPP_INKL_MOMS;
            } else {
              return prev;
            }

          default:
            return prev;
        }
      },
      0
    )
  );
  if (Number.isNaN(konteratBelopp)) {
    konteratBelopp = 0;
  }

  return konteratBelopp;
};

export const getNewKonteringsforslagValues = (
  konteringsforslagId: string,
  newSortNumber: number,
  radtyp: number,
  isAutoAdded: boolean,
  fakturaId: string,
  newValue: number,
  utlandskMomssats: number,
  utlandskAvdrag: number | null,
  utlandskAvdragsratt: number
): IKonteringsforslagUpdateObject => {
  switch (radtyp) {
    case 0:
    case null:
    case 2:
      return {
        id: konteringsforslagId,
        DEBET: newValue >= 0 ? Math.abs(newValue) : 0,
        KREDIT: newValue < 0 ? Math.abs(newValue) : 0,
        SORTERINGS_NR: newSortNumber,
        RADTYP: radtyp,
        _Associations: isAutoAdded
          ? {
              Faktura_Ref: fakturaId,
            }
          : undefined,
      };

    case 1: {
      const kostnad = getKostnadsBelopp(
        radtyp,
        0,
        newValue,
        0,
        0,
        null,
        null,
        null
      );

      return {
        id: konteringsforslagId,
        BELOPP_EXKL_MOMS: newValue,
        DEBET: kostnad >= 0 ? Math.abs(kostnad) : 0.0,
        KREDIT: kostnad < 0 ? Math.abs(kostnad) : 0.0,
        SORTERINGS_NR: newSortNumber,
        RADTYP: radtyp,
        _Associations: isAutoAdded
          ? {
              Faktura_Ref: fakturaId,
            }
          : undefined,
      };
    }
    case 5:
    case 6: {
      const utlandskMomsBelopp = getUtlandskMoms(newValue, utlandskMomssats);

      const kostnad = getKostnadsBelopp(
        radtyp,
        0,
        newValue,
        0,
        utlandskAvdragsratt,
        null,
        utlandskMomssats,
        utlandskMomsBelopp
      );

      return {
        id: konteringsforslagId,
        BELOPP_EXKL_MOMS: newValue,
        DEBET: kostnad >= 0 ? Math.abs(kostnad) : 0.0,
        KREDIT: kostnad < 0 ? Math.abs(kostnad) : 0.0,
        SORTERINGS_NR: newSortNumber,
        RADTYP: radtyp,
        UTL_MOMS: utlandskMomsBelopp,
        UTL_MOMS_SATS: utlandskMomssats,
        UTL_MOMS_AVDRAG: utlandskAvdrag,
        _Associations: isAutoAdded
          ? {
              Faktura_Ref: fakturaId,
            }
          : undefined,
      };
    }

    case 3:
    case 4: {
      const kostnad = getKostnadsBelopp(
        radtyp,
        newValue,
        0,
        0,
        0,
        null,
        null,
        null
      );
      return {
        id: konteringsforslagId,
        BELOPP_INKL_MOMS: newValue,
        DEBET: kostnad >= 0 ? Math.abs(kostnad) : 0.0,
        KREDIT: kostnad < 0 ? Math.abs(kostnad) : 0.0,
        SORTERINGS_NR: newSortNumber,
        RADTYP: radtyp,
        _Associations: isAutoAdded
          ? {
              Faktura_Ref: fakturaId,
            }
          : undefined,
      };
    }

    default:
      break;
  }

  return {
    id: konteringsforslagId,
    DEBET: newValue >= 0 ? Math.abs(newValue) : 0,
    KREDIT: newValue < 0 ? Math.abs(newValue) : 0,
    SORTERINGS_NR: newSortNumber,
    RADTYP: radtyp,
    _Associations: isAutoAdded
      ? {
          Faktura_Ref: fakturaId,
        }
      : undefined,
  };
};

export const isFieldError = (
  arg: IFieldValidation | string
): arg is IFieldValidation => typeof arg === 'object';

export const getIngaendeMoms = (
  belopp: number,
  inklusiveMoms: boolean,
  momsats: number | undefined | null,
  avdrag: number
) => {
  if (momsats) {
    if (inklusiveMoms) {
      const beloppExklMoms = belopp / (1 + momsats);

      return roundToTwoDecimals(beloppExklMoms * momsats * avdrag);
    } else {
      return roundToTwoDecimals(belopp * momsats * avdrag);
    }
  }
  return 0;
};

export const getInhemskKostnad = (
  belopp: number,
  inklusiveMoms: boolean,
  momsats: number | undefined | null,
  avdrag: number
) => {
  return belopp - getIngaendeMoms(belopp, inklusiveMoms, momsats, avdrag);
};

export const getUtlandskMoms = (
  belopp: number,
  momsats: number | undefined | null
) => {
  if (momsats) {
    return roundToTwoDecimals(belopp * momsats);
  }
  return 0;
};

export const getUtlandskAvdrag = (
  belopp: number,
  momsats: number | undefined | null,
  avdrag: number
) => {
  if (momsats) {
    return roundToTwoDecimals(belopp * momsats * avdrag);
  }
  return 0;
};

export const getUtlandskKostnad = (
  belopp: number,
  momsats: number | undefined | null,
  avdrag: number
) => {
  if (momsats) {
    return (
      belopp +
      getUtlandskMoms(belopp, momsats) -
      getUtlandskAvdrag(belopp, momsats, avdrag)
    );
  } else {
    return belopp;
  }
};

export const getKonteringAvdragsRatt = (
  momsHantering: TEDLRLeverantorfakturaMOMSHANTERINGEnum | null,
  konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All | null
) => {
  if (
    momsHantering ===
    TEDLRLeverantorfakturaMOMSHANTERINGEnum.UTLANDSK__ENLIGT_LEVERANTOR
  ) {
    return 1;
  } else {
    if (konteringsforslag?.MOMSPLIKTIG) {
      return konteringsforslag?.VIKT ? konteringsforslag?.VIKT : 0;
    } else {
      if (
        momsHantering ===
        TEDLRLeverantorfakturaMOMSHANTERINGEnum.UTLANDSK__ENLIGT_KODDEL
      ) {
        return 0;
      } else {
        return 1;
      }
    }
  }
};

export const getRubrikbelopp = (
  radtyp: number,
  existingKonteringSaknas: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All
): number | undefined => {
  switch (radtyp) {
    case 0:
    case null:
    case 2: {
      if (existingKonteringSaknas?.KREDIT > 0) {
        // Negera kredit
        return -existingKonteringSaknas.KREDIT;
      } else {
        return existingKonteringSaknas.DEBET;
      }
    }
    case 3:
    case 4:
      return existingKonteringSaknas.BELOPP_INKL_MOMS;

    case 1:
    case 5:
    case 6:
      return existingKonteringSaknas.BELOPP_EXKL_MOMS;

    default:
      return undefined;
  }
};

export const getPeriodiseraDisabledReason = (
  redovisningsTyp: TEDEKKontodelREDOVISN_TYPEnum | undefined,
  periodiseringBeloppEnhet: number | undefined | null,
  fakturabelopp: number,
  undantagPeriodisering: boolean | null | undefined
): string | undefined => {
  if (redovisningsTyp === TEDEKKontodelREDOVISN_TYPEnum.STALLNINGSKONTO) {
    return 'Balanskonton kan inte periodiseras';
  } else {
    //Om enheten inte har valt storlek eller EK_PERIODISERING_STORLEK är satt till 'N' så vi inte begränsa möjligheten att periodisera
    if (
      periodiseringBeloppEnhet != null &&
      fakturabelopp < periodiseringBeloppEnhet &&
      !undantagPeriodisering
    ) {
      return 'Fakturans belopp är mindre än beloppsgränsen och går därför inte att periodisera';
    }
  }
  return undefined;
};
